export const getCopyrightYearRange = (startYear = 2022) => {
    const currentYear = new Date().getFullYear();

    if (currentYear <= startYear) {
        return `${startYear}`;
    }

    return `${startYear}–${currentYear}`;
};
